<div class="snackbar-container"
[ngStyle]="{ 'background-color': getBackgroundColor(data.toastType) }"
>
    <div class="snackbar-card">
        <div class="btn-close">
            <lib-btn-close [buttonType]="'snackbar-exit'"></lib-btn-close>
        </div>
        <div class="message-div"
        [ngStyle]="{ 
            'border-left-color': getBorderColor(data.toastType)
        }"
        >
            <div>
                <h3 class="app mb-2">
                    {{ data.title ? data.title : data.toastType }}
                </h3>

                <p class="message">
                    {{ data.message }}
                </p>
            </div>
        </div>
    </div>
</div>
